


























import Card from '@/components/Card.vue'
import ActionButton from '@/components/ActionButton.vue'
import Table from '@/components/Table.vue'
import { getAgencies } from '@/api/Agency/agency.api'
import { Agency } from '@/api/Agency/agency.interface'
import { tableHandler } from '@/utils/mixins/tableHandler'
import PriceSettings from '@/components/Services/Remittances/PriceSettings/PriceSettings.vue'
import PriceSettingsDialog from '@/components/Services/Remittances/PriceSettings/PriceSettingsDialog.vue'
import { RemittancePrice } from '@/utils/interfaces/remittance.interface'
import {
  createTopUpPlatformPrice,
  getTopUpPlatformPrices,
} from '@/api/Topup/topup.api'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'

export default tableHandler<Agency>().extend({
  components: {
    appCard: Card,
    appActionButton: ActionButton,
    appTable: Table,
    appPriceSettings: PriceSettings,
    appPriceSettingsDialog: PriceSettingsDialog,
    FlatCard,
    FlatTable,
  },
  data() {
    return {
      filterModel: false,
      dialogModel: false,
      getter: getAgencies,
      priceItem: null as null | RemittancePrice,
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('address'),
          value: 'full_address',
        },
        {
          text: this.$t('remittance.price-settings'),
          value: 'price-settings',
        },
      ],
      poster: createTopUpPlatformPrice,
      platformPriceGetter: getTopUpPlatformPrices,
    }
  },
  methods: {
    onEdit(item: RemittancePrice) {
      this.priceItem = item
      this.dialogModel = true
    },
    onNew() {
      this.priceItem = null
      this.table.refresh()
    },
  },
})
